import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import React from 'react';

const baseUrlReq = process.env.REACT_APP_REQUEST_MANAGEMENT;

export const getAllRequestsAct = createAsyncThunk('getAllRequestsAct', async (queryParams, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlReq}/allRequests`, { params: queryParams });
        const { payload } = response.data;
        const { count, requests, paginationDetails } = payload;
        return { payload, count, requests, paginationDetails };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getMyRequestsAct = createAsyncThunk('getMyRequestsAct', async (req, thunkAPI) => {
    const { ulid, queryParams, status } = req;
    try {
        const response = await axios.get(`${baseUrlReq}/requests/${ulid}/${status}`, { params: queryParams });
        const { payload } = response.data;
        const { count, requests, paginationDetails } = payload;
        return { count, requests, paginationDetails };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getRequestById = createAsyncThunk('getRequestById', async (req, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlReq}/request/${req.requestId}/${req.userId}`);
        const { payload } = response.data;

        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const createProfile = createAsyncThunk('createProfile', async (payload, { dispatch, thunkAPI }) => {
    const { req, status } = payload;
    try {
        const response = await axios.post(`${baseUrlReq}/request`, req, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const { requestULID, serviceMessage, timestamp } = response.data;

        if (status === 'open') {
            toast.success(serviceMessage, {
                icon: <span className='msg-icon float-start ms-2 sf-check success-icon'></span>,
            });
        }
        return { requestULID, serviceMessage, timestamp };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        if (status === 'open') {
            toast.error(errorMessage);
        }

        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const updateProfile = createAsyncThunk('updateProfile', async (payload, { dispatch, thunkAPI }) => {
    const { req } = payload;
    try {
        const response = await axios.put(`${baseUrlReq}/request`, req, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        const { serviceMessage } = response.data;

        toast.success(serviceMessage, {
            icon: <span className='msg-icon float-start ms-2 sf-check success-icon'></span>,
        });
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);

        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getSpotCreditRequest = createAsyncThunk('getSpotCreditRequest', async (org_id, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlReq}/getSpotCreditRequest/${org_id}`);
        const { payload } = response.data;

        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
